/**
 * Signup page entry (Vite ESM).
 */
import { initSignupFormPage } from "./signup-form.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSignupFormPage, { once: true });
} else {
  initSignupFormPage();
}
